import React, {Component} from 'react'
import {Form, Input, Header, Icon, Checkbox, Select} from 'semantic-ui-react'
import countries from 'get-countries-info';
import postal from "postal-abbreviations";

class BillingAddress extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedState: props.data.billing.state || "",
            selectedCountry: props.data.billing.country || "USA",
            isSameAddress: props.data.isSameAddress || true
        }
    }


    handleCountryChange = (e, {value}) => {
        this.setState({selectedCountry: value})
        this.props.change('billing.country', value)
    }
    handleStateChange = (e, {value}) => {
        this.setState({selectedState: value})
        this.props.change('billing.state', value)
    }

    handleChange = (e) => {
        this.props.change(e.target.name, e.target.value)
    }
    handleNewAddress = (e) => {
        let isSameAddress = !this.state.isSameAddress
        this.setState({isSameAddress})
        this.props.change('isSameAddress', isSameAddress)
    }

    render() {
        let countryList = countries({}).map(country => {
            let data = {
                key: country.ISO.alpha2 + country.ISO.alpha3,
                text: country.name,
                value: country.ISO.alpha3,
                flag: country.ISO.alpha2.toLowerCase()
            }
            return data
        })
        let countrySelected = countries({ISO: this.state.selectedCountry})
        let states = countrySelected[0].provinces !== null ? countrySelected[0].provinces.map((state, index) => {
            return {key: index, text: state, value: postal(state) || state}
        }) : null
        return (
            <div>
                <Header as='h3' dividing>
                    <Icon name='location arrow'/>
                    <Header.Content>
                        Billing Address
                        <Header.Subheader>
                            Manage your billing address
                        </Header.Subheader>
                    </Header.Content>
                </Header>
                <Form.Field>
                    <Checkbox label='Same Billing Address' onChange={this.handleNewAddress.bind(this)}
                              checked={this.state.isSameAddress}/>
                </Form.Field>
                <Form.Field control={Input} label='First name' placeholder='First name'
                            readOnly={this.state.isSameAddress}
                            value={this.props.data.billing.first_name}
                            name='billing.first_name' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Input} label='Last name' placeholder='Last name'
                            readOnly={this.state.isSameAddress}
                            value={this.props.data.billing.last_name}
                            name='billing.last_name' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Input} label='Address Line 1' placeholder='Address Line 1'
                            readOnly={this.state.isSameAddress}
                            value={this.props.data.billing.address}
                            name='billing.address' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Input} label='Address Line 2' placeholder='Address Line 2'
                            readOnly={this.state.isSameAddress}
                            value={this.props.data.billing.address2}
                            name='billing.address2' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Input} label='City' placeholder='City'
                            readOnly={this.state.isSameAddress}
                            value={this.props.data.billing.city}
                            name='billing.city' onChange={this.handleChange.bind(this)}/>
                {
                    states !== null ? <Form.Field control={Select} label='State' fluid search selection
                                                  readOnly={this.state.isSameAddress}
                                                  options={states}
                                                  value={this.state.selectedState}
                                                  placeholder='State'
                                                  onChange={this.handleStateChange.bind(this)}
                                                  autoComplete='state'/> : null
                }

                <Form.Field control={Input} label='Zip Code' placeholder='Zip Code'
                            readOnly={this.state.isSameAddress}
                            value={this.props.data.billing.zip}
                            name='billing.zip' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Select} label='Country' fluid search selection
                            readOnly={this.state.isSameAddress}
                            options={countryList} value={this.state.selectedCountry}
                            placeholder='Country'
                            onChange={this.handleCountryChange.bind(this)}
                            autoComplete='country-name'/>


            </div>
        )
    }
}

export default BillingAddress


// WEBPACK FOOTER //
// ./src/containers/register/BillingAddress.js